import BaseRepository from 'src/api/repositories/base.repository';
import config from 'src/config';

export default class ESSRepository extends BaseRepository {
  protected static readonly baseURL: string = config.api.essBaseUrl;
}
